<div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="manager-roles-dialog" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Manager Roles Explained</h5>
                <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
            </div>
            <div class="modal-body">
                <h6 class="mb-3">Landlord/Merchant Communications</h6>

                <div class="table-responsive">
                    <table class="table table-sm table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 40%">Communication Type</th>
                                <th scope="col" class="text-center" style="width: 15%">
                                    <div class="d-flex flex-column align-items-center">
                                        <i class="fas fa-building text-primary mb-1"></i>
                                        <small>Building Manager</small>
                                    </div>
                                </th>
                                <th scope="col" class="text-center" style="width: 15%">
                                    <div class="d-flex flex-column align-items-center">
                                        <i class="fas fa-chart-line text-info mb-1"></i>
                                        <small>Portfolio Manager</small>
                                    </div>
                                </th>
                                <th scope="col" class="text-center" style="width: 15%">
                                    <div class="d-flex flex-column align-items-center">
                                        <i class="fas fa-calculator text-warning mb-1"></i>
                                        <small>Finance Manager</small>
                                    </div>
                                </th>
                                <th scope="col" class="text-center" style="width: 15%">
                                    <div class="d-flex flex-column align-items-center">
                                        <i class="fas fa-user-cog text-success mb-1"></i>
                                        <small>General Manager</small>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Income summary and monthly reports</td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                            </tr>
                            <tr>
                                <td>Communications around listing parking/creating parking bays</td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                            </tr>
                            <tr>
                                <td>Parking request approval communications</td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                            </tr>
                            <tr>
                                <td>Access control communications</td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                            </tr>
                            <tr>
                                <td>Parker contracts breach communications</td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                            </tr>
                            <tr>
                                <td>Payouts and monthly statement communications</td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-danger"><i class="fas fa-times"></i></td>
                            </tr>
                            <tr>
                                <td>Member Invitation</td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                                <td class="text-center text-success"><i class="fas fa-check"></i></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="alert alert-light mt-4">
                    <small class="text-muted">
                        <i class="fas fa-info-circle me-1"></i>
                        You can assign multiple roles to the same person, and roles can be changed at any time. Each role determines which communications that person will receive.
                    </small>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="merchant" class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <h2 *ngIf="showHeading" class="mb-4">Managers</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <form (submit)="save()" [formGroup]="emailFormGroup" class="needs-validation" novalidate>
                <label>Email Address</label>
                <div class="input-group mb-3">
                    <input
                        aria-describedby="email-button"
                        aria-label="Email Address"
                        autocomplete="off"
                        class="form-control"
                        formControlName="email"
                        id="email"
                        name="email"
                        placeholder="Email Address"
                        required
                        type="email"
                    />
                    <button class="btn btn-outline-primary" id="email-button" type="submit">Invite</button>
                </div>
            </form>
        </div>
    </div>

    <div class="alert alert-info">
        <a data-bs-target="#manager-roles-dialog" data-bs-toggle="modal" href=""><strong>Learn more</strong></a> about each member role
    </div>

    <div *ngIf="!hasPortfolioManagers() && merchantMembers.length > 0" class="alert alert-danger" style="background-color: #dc3545; border-color: #b02a37; color: white; border-width: 2px">
        <div class="d-flex align-items-center">
            <i class="fas fa-exclamation-triangle me-2" style="font-size: 1.5rem; color: #ffeb3b"></i>
            <div>
                <strong style="font-size: 1.1rem; color: white">CRITICAL WARNING: No Portfolio Managers assigned!</strong>
                <p class="mb-0 mt-1" style="font-weight: 500; color: white">
                    You need at least one Portfolio Manager to receive and respond to parking requests. Without a Portfolio Manager, new parking requests will not be processed and will automatically
                    time out after 24 hours.
                </p>
            </div>
        </div>
    </div>

    <div *ngFor="let merchantMember of merchantMembers" class="row">
        <div class="col-md-12">
            <div class="card corner-radius mt-3 w-100">
                <div class="card-body">
                    <span *ngIf="merchantMember.uid && merchant.owner == merchantMember.uid" class="badge bg-dark text-light ms-2 float-end">Owner</span>
                    <div class="card-title d-inline-block email-address mb-0">
                        <strong *ngIf="!merchantMember.uid || !clientMemberMap[merchantMember.uid] || !clientMemberMap[merchantMember.uid].firstName">{{ merchantMember.email }}</strong>
                        <strong *ngIf="merchantMember.uid && clientMemberMap[merchantMember.uid] && clientMemberMap[merchantMember.uid].firstName"
                            >{{ clientMemberMap[merchantMember.uid].firstName }} {{ clientMemberMap[merchantMember.uid].lastName }}</strong
                        >
                        &nbsp;
                        <span *ngIf="!merchantMember.uid" class="badge bg-danger">Not registered</span>
                    </div>
                    <div *ngIf="merchantMember.uid && clientMemberMap[merchantMember.uid] && clientMemberMap[merchantMember.uid].firstName" class="email-address">
                        {{ merchantMember.email }}
                    </div>
                    <div [ngClass]="{ 'can-edit': canEditRoles }" class="mb-3 mt-1">
                        <span
                            (click)="updateRoles(merchantMember, merchantRoles.BUILDING_MANAGER)"
                            [ngClass]="{ active: merchantMember.roles && merchantMember.roles.indexOf(merchantRoles.BUILDING_MANAGER) > -1 }"
                            class="badge badge-role bg-grey me-2"
                            >Building Manager</span
                        >
                        <span
                            (click)="updateRoles(merchantMember, merchantRoles.PORTFOLIO_MANAGER)"
                            [ngClass]="{ active: merchantMember.roles && merchantMember.roles.indexOf(merchantRoles.PORTFOLIO_MANAGER) > -1 }"
                            class="badge badge-role bg-grey me-2"
                            >Portfolio Manager</span
                        >
                        <span
                            (click)="updateRoles(merchantMember, merchantRoles.FINANCE_MANAGER)"
                            [ngClass]="{ active: merchantMember.roles && merchantMember.roles.indexOf(merchantRoles.FINANCE_MANAGER) > -1 }"
                            class="badge badge-role bg-grey me-2"
                            >Finance Manager</span
                        >
                        <span
                            (click)="updateRoles(merchantMember, merchantRoles.GENERAL_MANAGER)"
                            [ngClass]="{ active: merchantMember.roles && merchantMember.roles.indexOf(merchantRoles.GENERAL_MANAGER) > -1 }"
                            class="badge badge-role bg-grey me-2"
                            >General Manager</span
                        >
                    </div>
                    <div>
                        <div *ngIf="merchant.owner != merchantMember.uid" class="d-inline-block">
                            <a (click)="deleteMember(merchantMember)" class="text-danger small" href="">Remove Manager</a>
                        </div>
                        <div *ngIf="merchantMember.uid && (merchant.owner == uid || auth.isAdmin) && merchant.owner != merchantMember.uid" class="d-inline-block ms-3">
                            <a (click)="transferOwnership(merchantMember)" class="text-info small" href="">Transfer Ownership</a>
                        </div>
                        <div *ngIf="!merchantMember.uid" class="d-inline-block ms-3"><a (click)="resendInvite(merchantMember)" class="text-info small" href="">Resend Invite</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
